import uuid from 'uuid/v4'

const FAKE_RESPONSE_PARAGRAPHS = [
  'Yo opino que el coral blanco o el ambiente que estamos manejando, lo estamos contaminando de una manera inigmi, i, im, inimaginablemente, inig, inigmante.',
  'Esto quiere decir que el coral blanco se está maltratando, eh, pues esas algas rojas, eh, las algas verde puede servir como combustible.',
  'El carros sólo necesitamos el petróleo realmente y si supiéramos manejar un buen gobierno, no necesitamo nada solar, ni lenguas náhual y eso, no metemos nada en aztecas porque si son los que conservan todo.',
  'Y si conserváramos todo bosques, flores, selvas, nuestros huertos, nuestras calles fueran kioscos? no estuviéramos como estuviéramos ahorita, porque el coral se está maltratando moralmente y los tiburones les cortan las aletas y los tiran así.',
  'Hay que pensar en la contin, en la contien, contamina, en la contaminación, las algas verdes pueden ser un combustible, y el agua, y las los lenguajes náhual no impiden que aprendamos, y celulares solares, licuadoras, menos.',
  'Bueno, nada más nos falta un puntito. Nada más que no queremos razonar. No pego, no grito, no empujo en el metro que me avientan y no entienden eso, menos esto, porque yo sí tengo ese IQ. Nunca, nunca. No se que IQ tengo No me importa y adiós. Soy una persona normal.',
]

export default {
  createNewChat() {
    return {
      data: {
        threadId: uuid(),
      },
    }
  },

  sendMessage() {
    const sleep = ms => new Promise(r => setTimeout(r, ms))

    return (async function*() {
      const id = uuid()
      const paragraph =
        FAKE_RESPONSE_PARAGRAPHS[
          Math.floor(Math.random() * FAKE_RESPONSE_PARAGRAPHS.length)
        ]

      const tokens = paragraph.split(/\s+/)

      for (let i = 0; i < tokens.length; i++) {
        yield { id, content: tokens[i] }
        await sleep(60)
      }
    })()
  },
}
